<template>
  <div class="attachment_preview_show" v-if="attachments">
    <div class="prview_example">
      <div
        class="preview_example_inner"
        v-for="(attachment, index) in attachments"
        :key="'attachment_' + index"
        @click.prevent="
          showDownloadFile(
            attachment.file_path,
            attachment.file_extension,
            attachment.original_file_name
          )
        "
      >
        <template
          v-if="
            ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(
              attachment.file_extension
            )
          "
        >
          <img :src="attachment.file_path" />
        </template>
        <template v-if="['pdf'].includes(attachment.file_extension)">
          <embed :src="attachment.file_path" width="150" />
        </template>
        <template
          v-if="
            ['xls', 'xlsx', 'xlm', 'xla', 'xlc', 'xlt', 'xlw', 'csv'].includes(
              attachment.file_extension
            )
          "
        >
          <i class="fas fa-file-excel fa-10x"></i>
        </template>
        <template v-if="['docx'].includes(attachment.file_extension)">
          <i class="fas fa-file-word fa-10x"></i>
        </template>
        <template v-if="['zip'].includes(attachment.file_extension)">
          <i class="fas fa-file-archive fa-10x"></i>
        </template>
        <div class="preview_text">
          <span>{{ attachment.original_file_name }}</span>
        </div>
        <div class="preview_text_details">
          <div>{{ attachment.original_file_name }}</div>
          <div>{{ generateFileSize(attachment.original_size) }}</div>
          <div>
            <span
              @click.prevent="
                downloadFile(
                  attachment.file_path,
                  attachment.original_file_name
                )
              "
              ><i class="lni lni-download"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
    <FileModal
      v-if="showFileModal"
      :filePath="filePath"
      :original_file_name="original_file_name"
      @closeModal="hideFileModal"
    />
  </div>
</template>
<script>
import FileModal from './FileModal';

export default {
  name: 'attachment-preview-component',
  components: { FileModal },
  data() {
    return {
      showFileModal: false,
      filePath: '',
      original_file_name: '',
    };
  },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },
  mounted() {},
  methods: {
    generateFileSize(size) {
      let formatted_size = '';
      if (size / (1024 * 1024) >= 1) {
        formatted_size = (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        formatted_size = (size / 1024).toFixed(2) + ' KB';
      }
      return formatted_size;
    },
    downloadFile(filePath, originalFileName) {
      const a = document.createElement('a');
      a.href = filePath;
      // let filenameArr  = filePath.split('/');
      // let filename = filenameArr[filenameArr.length-1];
      // a.download = filename;
      a.download = originalFileName;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    showDownloadFile(filePath, ext, originalFileName) {
      if (['gif', 'png', 'jpg', 'jpeg', 'JPG', 'pdf'].includes(ext)) {
        this.filePath = filePath;
        this.original_file_name = originalFileName;
        this.showFileModal = true;
      }
    },
    hideFileModal() {
      this.filePath = '';
      this.original_file_name = '';
      this.showFileModal = false;
    },
  },
};
</script>
<style scoped>
.preview_example_inner {
  height: 150px !important;
}
</style>
